"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chart = void 0;
const chart_labels_1 = require("src/libs/chart-labels");
const chart_metrics_1 = require("src/components/coins/coins-details/chart-metrics");
const wait_on_1 = require("src/libs/wait-on");
const reduce_precision_1 = require("reduce-precision");
const chart_settings_1 = require("src/components/coins/coins-details/chart-settings");
const formatterIrt = new reduce_precision_1.NumberFormatter({
    language: "fa",
    template: "irt",
    'precision': 'auto',
});
const formatterUsd = new reduce_precision_1.NumberFormatter({
    language: "en",
    template: "usd",
    'precision': 'auto',
});
// Range buttons let the press paint before the (often synchronous, cached) chart rebuild; hidden tabs never paint.
const afterNextPaint = () => new Promise((resolve) => {
    if (document.visibilityState !== 'visible')
        return resolve();
    requestAnimationFrame(() => setTimeout(resolve, 0));
});
class chart {
    constructor(container, useMakeChart3, prefix, chartHeight, initialState) {
        var _a;
        this.stableCoins = ['zusd', 'yusd-stablecoin', 'sora-synthetic-usd', 'xsgd', 'straitsx-indonesia-rupiah', 'cryptofranc', 'wemix-dollar', 'wanusdt', 'venus-usdc', 'venus-usdt', 'vnx-euro', 'venus-dai', 'vnx-swiss-franc', 'venus-busd', 'vai', 'token-force-usd', 'terrausd', 'usdz', 'usdx-kava', 'verified-usd', 'tether', 'sperax-usd', 'usdp', 'paxos-standard', 'usdk', 'usdj', 'usdh', 'usdd', 'usdcash-token', 'usd-coin', 'trueusd', 'bilira', 'susd', 'savings-dai', 'steem-dollars', 'rubcash-token', 'reserve', 'rmbcash-token', 'paypal-usd', 'origin-dollar', 'tether-mxnt', 'mstable-usd', 'meter-stable', 'moremoney-usd', 'mai', 'magic-internet-money', 'moola-celo-usd', 'moola-celo-eur', 'liquity-usd', 'inter-stable-token', 'rupiah-token', 'husd', 'helio-money', 'gyen', 'gemini-dollar', 'frax', 'fei-usd', 'first-digital-usd', 'tether-eurt', 'stasis-euro', 'euro-coin', 'empty-set-dollar', 'eosdt', 'davos-protocol', 'inverse-finance-dola-stablecoin', 'djed', 'overnight-dai', 'multi-collateral-dai', 'celo-dollar', 'coin98-dollar', 'celo-euro', 'binance-usd', 'brz', 'brcp-token', 'binance-idr', 'basis-cash', 'angle-protocol', 'gho', 'decentralized-usd', 'xdaistable', 'ton-bridged-usdt', 'one-cash', 'parachute', 'mstable-usd', 'usn', 'ton-bridged-usdc', 'jones-usdc', 'space-rebase-xusd', 'xdollar-stablecoin', 'jpy-coin', 'jpycoin', 'usd-bancor', 'digixdao', 'bitcny', 'digix-gold-token', 'karatgold-coin', 'diviner-protocol', 'diamond-platform-token', 'cad-coin', 'iron-finance', 'statik', 'spiceusd'];
        this.isFirstTime = 1;
        this.enShortMonthes = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        this.faMonthes = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
        this.isStableCoin = false;
        this.lastRequestDataParams = {};
        this.chartData = {};
        this.chartHeight = 310;
        this.useMakeChart3 = false;
        this.prefix = '';
        this.chartType = 'usd';
        this.livePriceEnabled = true;
        this.logarithmicEnabled = false;
        this.metricsEnabled = false;
        this.metric = 'price';
        this.mobileRangeTrailingSlots = 0;
        this.requestSequence = 0;
        this.refreshPending = false;
        this.chartRequestPending = false;
        //@ts-ignore
        if (coin_info.type == 'fiat') {
            this.isStableCoin = true;
        }
        else
            this.isStableCoin = this.stableCoins.includes(coin_info.slug);
        this.lastRequestDataParams = initialState
            ? { range: initialState.range, selected: initialState.selected }
            : { range: '24h', selected: 0 };
        this.metricsEnabled = Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.metricsEnabled);
        this.mobileRangeTrailingSlots = Number(initialState === null || initialState === void 0 ? void 0 : initialState.mobileRangeTrailingSlots) || 0;
        if (initialState === null || initialState === void 0 ? void 0 : initialState.currency)
            this.chartType = initialState.currency;
        if (typeof (initialState === null || initialState === void 0 ? void 0 : initialState.livePrice) === 'boolean')
            this.livePriceEnabled = initialState.livePrice;
        if (typeof (initialState === null || initialState === void 0 ? void 0 : initialState.logarithmic) === 'boolean')
            this.logarithmicEnabled = initialState.logarithmic;
        this.container = container;
        if (prefix) {
            this.prefix = prefix;
        }
        if (useMakeChart3 !== undefined) {
            this.useMakeChart3 = useMakeChart3;
        }
        if (chartHeight)
            this.chartHeight = chartHeight;
        if (this.prefix === 'coindetails') {
            (_a = document.getElementById(container)) === null || _a === void 0 ? void 0 : _a.addEventListener('arz:chart-refresh', (event) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const signal = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.signal;
                if (!signal || signal.aborted || this.refreshPending || this.chartRequestPending || !((_b = this.chart) === null || _b === void 0 ? void 0 : _b.renderTo) || !this.coinsHistory)
                    return;
                this.refreshPending = true;
                try {
                    yield this.makeChart(signal);
                }
                finally {
                    this.refreshPending = false;
                }
            }));
        }
        this.init();
    }
    setCurrency(currency) {
        var _a;
        this.chartType = currency === 'irt' ? 'irt' : 'usd';
        if (!((_a = this.chart) === null || _a === void 0 ? void 0 : _a.renderTo))
            return false;
        const visibility = (0, chart_settings_1.getChartCurrencyVisibility)(this.metric === 'price' ? this.chartType : 'usd');
        visibility.series.forEach((visible, index) => {
            var _a;
            (_a = this.chart.series[index]) === null || _a === void 0 ? void 0 : _a.setVisible(visible, false);
        });
        visibility.axes.forEach((visible, index) => {
            var _a;
            (_a = this.chart.yAxis[index]) === null || _a === void 0 ? void 0 : _a.update({ visible }, false);
        });
        this.rescalePriceAxes(false);
        this.chart.redraw();
        this.changePercentInCoinPdp();
        return true;
    }
    setMetric(metric) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.metricsEnabled || !Object.prototype.hasOwnProperty.call(chart_metrics_1.COIN_CHART_METRICS, metric))
                return false;
            this.metric = metric;
            return this.makeChart();
        });
    }
    setLivePriceEnabled(enabled) {
        this.livePriceEnabled = Boolean(enabled);
    }
    // Visible price/metric range for one y-axis: the full selected range plus mobile/desktop padding.
    priceAxisBounds(sourcePoints, chartWidth) {
        const values = sourcePoints
            .map((point) => Number(typeof point === 'number' ? point : Array.isArray(point) ? point[1] : point === null || point === void 0 ? void 0 : point.y))
            .filter((value) => Number.isFinite(value) && value > 0);
        if (this.metric !== 'price' && !this.logarithmicEnabled && sourcePoints.some((point) => (point === null || point === void 0 ? void 0 : point.y) === 0))
            values.push(0);
        if (!values.length)
            return null;
        const extremes = values.reduce((result, value) => ({
            min: Math.min(result.min, value),
            max: Math.max(result.max, value),
        }), { min: values[0], max: values[0] });
        if (this.metric !== 'price') {
            return (0, chart_metrics_1.getMetricAxisBounds)(extremes.min, extremes.max, this.logarithmicEnabled, chartWidth <= 600) || null;
        }
        const scaleMin = this.logarithmicEnabled ? Math.log(extremes.min) : extremes.min;
        const scaleMax = this.logarithmicEnabled ? Math.log(extremes.max) : extremes.max;
        const scaleRange = scaleMax - scaleMin;
        const isMobileChart = chartWidth <= 600;
        const bottomPadding = scaleRange * (isMobileChart ? 0.2 : 0.08);
        const topPadding = scaleRange * (isMobileChart ? 0.2 : 0.08);
        const visibleMin = scaleRange > 0
            ? (this.logarithmicEnabled
                ? Math.exp(scaleMin - bottomPadding)
                : Math.max(0, scaleMin - bottomPadding))
            : extremes.min;
        const visibleMax = scaleRange > 0
            ? (this.logarithmicEnabled ? Math.exp(scaleMax + topPadding) : scaleMax + topPadding)
            : extremes.max;
        return { min: visibleMin, max: visibleMax };
    }
    priceAxisSource(axisIndex) {
        const rangeData = this.chartData[this.lastRequestDataParams.name];
        return axisIndex === 1 ? rangeData === null || rangeData === void 0 ? void 0 : rangeData.dollar : rangeData === null || rangeData === void 0 ? void 0 : rangeData.toman;
    }
    rescalePriceAxes(redraw = true) {
        var _a;
        if (this.prefix !== 'coindetails' || !((_a = this.chart) === null || _a === void 0 ? void 0 : _a.renderTo))
            return false;
        const seriesToAxis = [[0, 1], [1, 0]];
        seriesToAxis.forEach(([seriesIndex, axisIndex]) => {
            var _a, _b;
            const series = this.chart.series[seriesIndex];
            const sourcePoints = this.priceAxisSource(axisIndex)
                || ((_a = series === null || series === void 0 ? void 0 : series.options) === null || _a === void 0 ? void 0 : _a.data)
                || (series === null || series === void 0 ? void 0 : series.points)
                || [];
            const bounds = this.priceAxisBounds(sourcePoints, this.chart.renderTo.clientWidth);
            if (bounds)
                (_b = this.chart.yAxis[axisIndex]) === null || _b === void 0 ? void 0 : _b.setExtremes(bounds.min, bounds.max, false, false);
        });
        if (redraw)
            this.chart.redraw();
        return true;
    }
    setLogarithmicEnabled(enabled) {
        var _a;
        this.logarithmicEnabled = Boolean(enabled);
        if (!((_a = this.chart) === null || _a === void 0 ? void 0 : _a.renderTo))
            return false;
        this.chart.series.slice(0, 2).forEach((series) => {
            series.update({ threshold: null, visible: series.visible }, false);
        });
        this.chart.yAxis.slice(0, 2).forEach((axis) => {
            axis.update({
                type: this.logarithmicEnabled ? 'logarithmic' : 'linear',
                visible: axis.visible,
                tickAmount: this.logarithmicEnabled ? undefined : 5,
                min: null,
                max: null,
            }, false);
            axis.setExtremes(null, null, false, false);
        });
        this.chart.series.slice(0, 6).forEach((series) => {
            series.isDirty = true;
            series.isDirtyData = true;
        });
        this.setCurrency(this.chartType);
        return true;
    }
    alignExtremaPointers(chart) {
        const chartRect = chart.container.getBoundingClientRect();
        const scale = chartRect.width / chart.chartWidth;
        if (!Number.isFinite(scale) || scale <= 0)
            return;
        chart.series.forEach((series) => {
            if (!series.visible || series.options.className !== 'arz-chart-extrema-flag')
                return;
            series.points.forEach((point) => {
                var _a, _b, _c;
                const badge = (_c = (_b = (_a = point.graphic) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.element) === null || _c === void 0 ? void 0 : _c.querySelector('.arz-chart-extrema-badge');
                if (!badge)
                    return;
                const badgeRect = badge.getBoundingClientRect();
                if (!badgeRect.width)
                    return;
                const targetX = chartRect.left + series.xAxis.toPixels(point.x) * scale;
                // The badge can be shifted at either plot edge; its pointer must keep the point's X.
                const pointerX = (targetX - badgeRect.left) / scale - badge.clientLeft;
                if (Number.isFinite(pointerX))
                    badge.style.setProperty('--arz-extrema-pointer-x', `${pointerX}px`);
            });
        });
    }
    extremaFlagTitle(formattedValue, anchor) {
        const pointerPosition = anchor === 'bottom'
            ? 'bottom:-4px;border-right:1px solid var(--arz-color-border);border-bottom:1px solid var(--arz-color-border)'
            : 'top:-4px;border-top:1px solid var(--arz-color-border);border-left:1px solid var(--arz-color-border)';
        return `<span class="arz-chart-extrema-badge arz-chart-extrema-badge--anchor-${anchor}" dir="ltr" style="position:relative;display:inline-flex;align-items:center;min-height:22px;padding:2px 7px;border:1px solid var(--arz-color-border);border-radius:6px;background:var(--arz-color-surface-elevated);color:var(--arz-color-text-soft);font-size:11px;font-weight:600;line-height:16px;white-space:nowrap;box-sizing:border-box;pointer-events:none"><span aria-hidden="true" style="position:absolute;${pointerPosition};left:var(--arz-extrema-pointer-x,50%);width:6px;height:6px;background:var(--arz-color-surface-elevated);transform:translateX(-50%) rotate(45deg)"></span><span>${formattedValue}</span></span>`;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, wait_on_1.WaitOn)('coin_info');
            yield (0, wait_on_1.WaitOn)('arzConstants');
            yield (0, wait_on_1.WaitOn)('window.Highcharts');
            yield (0, wait_on_1.WaitOn)('arzDigital.chartLoading');
            this.coinsHistory = yield window.ArzLibs.GetCoinHistory();
            this.makeChart();
        });
    }
    changePercentInCoinPdp() {
        if (!document.querySelector('#coin-details-page')) {
            return;
        }
        let range = 'all';
        switch (this.lastRequestDataParams.range) {
            case '24h':
                range = '24h';
                break;
            case '1w':
                range = '7d';
                break;
            case '1m':
                range = '30d';
                break;
            case '3m':
                range = '3m';
                break;
            case '1y':
                range = '1y';
                break;
        }
        // @ts-ignore
        if (this.chartType == 'irt') {
            range = 'irt_' + range;
        }
        range = 'price_change_percent_' + range;
        // @ts-ignore
        coin_info.wsSelectedPercent = range;
        // @ts-ignore
        const percent = coin_info[range] * 1;
        // @ts-ignore
        if (window.doFiatsChange) {
            const ChangedCoin = { [coin_info.slug]: {
                    dollarPrice: parseFloat(coin_info.price),
                    irtPrice: parseFloat(coin_info.priceIrt),
                    // @ts-ignore
                    changePrice24: coin_info.price_change_percent_24h,
                    // @ts-ignore
                    changePrice7d: coin_info.price_change_percent_7d,
                    wsSelectedPercent: percent
                } };
            // @ts-ignore
            doFiatsChange(undefined, ChangedCoin);
        }
    }
    makeChart(refreshSignal) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            var name = '', range = this.lastRequestDataParams.range;
            name = this.lastRequestDataParams.range;
            this.lastRequestDataParams.name = name;
            var elem = this.container;
            if ($("#" + elem).length == 0)
                return;
            if (!refreshSignal)
                arzDigital.chartLoading({
                    show: 1,
                    chartElem: '#' + elem,
                });
            const sequence = ++this.requestSequence;
            this.chartRequestPending = true;
            const metric = this.metric;
            const element = document.getElementById(elem);
            if (!refreshSignal)
                (_b = (_a = element === null || element === void 0 ? void 0 : element.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.arz-chart-metric-error')) === null || _b === void 0 ? void 0 : _b.remove();
            try {
                let res;
                if (metric !== 'price' && this.metricsEnabled) {
                    const apiRange = { '24h': '1d', '1w': '7d', ALL: 'all' }[range] || range;
                    const response = yield fetch(`${arzConstants.muninnBaseUrl}/v1/assets/metrics?id=${encodeURIComponent(coin_info.idnameid)}&range=${encodeURIComponent(apiRange)}&type=${metric}${refreshSignal ? `&_=${Date.now()}` : ''}`, refreshSignal ? { cache: 'no-store', signal: refreshSignal } : undefined);
                    if (!response.ok)
                        throw new Error('Metric request failed');
                    res = (0, chart_metrics_1.normalizeMetricHistory)(yield response.json());
                }
                else {
                    res = yield this.coinsHistory.getHistory(name, coin_info.idnameid, range, this.prefix, refreshSignal);
                }
                if (sequence !== this.requestSequence || (refreshSignal === null || refreshSignal === void 0 ? void 0 : refreshSignal.aborted))
                    return false;
                if (!res)
                    throw new Error('Chart unavailable');
                const zoom = refreshSignal ? (_e = (_d = (_c = this.chart) === null || _c === void 0 ? void 0 : _c.xAxis) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.getExtremes() : null;
                this.chartData[name] = res;
                if (this.useMakeChart3)
                    yield this.makeChart3();
                else
                    yield this.makeChart2();
                if (zoom && (zoom.userMin !== undefined || zoom.userMax !== undefined)) {
                    (_h = (_g = (_f = this.chart) === null || _f === void 0 ? void 0 : _f.xAxis) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.setExtremes(zoom.userMin, zoom.userMax, true, false);
                }
                return true;
            }
            catch (_error) {
                // Background failures leave the last successful chart on screen.
                if (refreshSignal)
                    return false;
                if (sequence !== this.requestSequence)
                    return false;
                // Never leave a previous price curve labeled as the selected metric.
                (_k = (_j = this.chart) === null || _j === void 0 ? void 0 : _j.series) === null || _k === void 0 ? void 0 : _k.forEach((series) => series.setData([], false));
                (_m = (_l = this.chart) === null || _l === void 0 ? void 0 : _l.yAxis) === null || _m === void 0 ? void 0 : _m.forEach((axis) => axis.removePlotLine('lastPrice'));
                (_o = this.chart) === null || _o === void 0 ? void 0 : _o.redraw();
                const message = document.createElement('div');
                message.className = 'arz-chart-metric-error';
                message.setAttribute('role', 'status');
                message.textContent = 'داده‌های این نمودار در دسترس نیست. ';
                const retry = document.createElement('button');
                retry.type = 'button';
                retry.textContent = 'تلاش دوباره';
                retry.addEventListener('click', () => this.makeChart());
                message.appendChild(retry);
                (_p = element === null || element === void 0 ? void 0 : element.parentElement) === null || _p === void 0 ? void 0 : _p.appendChild(message);
                return false;
            }
            finally {
                if (sequence === this.requestSequence)
                    this.chartRequestPending = false;
                if (!refreshSignal && sequence === this.requestSequence)
                    arzDigital.chartLoading({ show: 0, chartElem: '#' + elem });
            }
        });
    }
    ;
    makeChart2() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const selfClass = this;
            var elem = this.container;
            var tomanIsVisible = 0;
            var isFirstTime = this.isFirstTime;
            if (this.chart != undefined) {
                tomanIsVisible = this.chart.series[1].visible;
                this.chart.destroy();
            }
            this.chartType = (0, chart_settings_1.resolveChartCurrencyForRender)(this.chartType, Boolean(isFirstTime), this.isStableCoin, Boolean(tomanIsVisible));
            var data = this.chartData[this.lastRequestDataParams.name];
            // @ts-ignore
            window.chartData = data;
            data.dmin.title = this.extremaFlagTitle(formatterUsd.toString(data.dmin.y), 'top');
            data.dmax.title = this.extremaFlagTitle(formatterUsd.toString(data.dmax.y), 'bottom');
            data.tmin.title = this.extremaFlagTitle((0, chart_labels_1.rtlChartAmount)(formatterIrt.toString(data.tmin.y)), 'top');
            data.tmax.title = this.extremaFlagTitle((0, chart_labels_1.rtlChartAmount)(formatterIrt.toString(data.tmax.y)), 'bottom');
            var tmin = data.tmin;
            var tmax = data.tmax;
            var dmin = data.dmin;
            var dmax = data.dmax;
            var lastIndex = data.dollar.length - 1;
            var lastDataDollar = data.dollar[lastIndex];
            var lastDataToman = data.toman[lastIndex];
            const rootStyles = getComputedStyle(document.documentElement);
            const positiveColor = rootStyles.getPropertyValue('--arz-color-positive-strong').trim() || '#008c4c';
            const onStateColor = rootStyles.getPropertyValue('--arz-color-on-state').trim() || '#fff';
            const gridLineColor = rootStyles.getPropertyValue('--arz-color-divider-soft').trim() || 'rgba(100, 116, 139, .16)';
            let args = {
                chart: {
                    alignTicks: false,
                    events: {
                        render: function () { selfClass.alignExtremaPointers(this); },
                    },
                    panning: false,
                    height: this.chartHeight + "px",
                    style: {
                        fontFamily: 'yekan bakh',
                    },
                    marginLeft: 0,
                    marginRight: 0,
                    plotBorderWidth: 0
                },
                credits: {
                    href: '',
                    text: '',
                },
                yAxis: [
                    {
                        type: this.logarithmicEnabled ? 'logarithmic' : 'linear',
                        tickAmount: this.logarithmicEnabled ? undefined : 5,
                        startOnTick: false,
                        endOnTick: false,
                        visible: this.chartType == 'irt' ? true : false,
                        gridLineColor,
                        lineColor: 'transparent',
                        lineWidth: 0,
                        tickWidth: 0,
                        labels: {
                            reserveSpace: false,
                            align: 'right',
                            x: -8,
                            //@ts-ignore
                            formatter: function () {
                                //@ts-ignore
                                return (0, chart_labels_1.rtlChartAmount)(formatterIrt.toString(Number(Number(this.value).toPrecision(12))));
                            }
                        }
                    }, {
                        type: this.logarithmicEnabled ? 'logarithmic' : 'linear',
                        tickAmount: this.logarithmicEnabled ? undefined : 5,
                        startOnTick: false,
                        endOnTick: false,
                        visible: this.chartType == 'irt' ? false : true,
                        gridLineColor,
                        lineColor: 'transparent',
                        lineWidth: 0,
                        tickWidth: 0,
                        labels: {
                            reserveSpace: false,
                            align: 'right',
                            x: -8,
                            //@ts-ignore
                            formatter: function () {
                                //@ts-ignore
                                return formatterUsd.toString(Number(Number(this.value).toPrecision(12)));
                            }
                        }
                    }
                ],
                xAxis: {
                    ordinal: false,
                    gridLineWidth: 0,
                    maxPadding: 0.02,
                    labels: {
                        //@ts-ignore
                        formatter: function () {
                            //@ts-ignore
                            const gdate = new Date(this.value);
                            const yearFormat = new Intl.DateTimeFormat('fa-IR', { year: 'numeric' });
                            //const monthFormat = new Intl.DateTimeFormat('fa-IR', { month: 'numeric' });
                            const monthFormat = new Intl.DateTimeFormat('fa-IR', { month: 'long' });
                            const dayFormat = new Intl.DateTimeFormat('fa-IR', { day: '2-digit' });
                            const year = yearFormat.format(gdate);
                            const famonth = monthFormat.format(gdate);
                            const day = dayFormat.format(gdate);
                            //@ts-ignore
                            var time = gdate.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' });
                            //@ts-ignore
                            var finalDate = this.dateTimeLabelFormat.toLowerCase().replace('%b', famonth).replace('%e', day).replace('%y', year).replace('%h:%m', time);
                            return finalDate;
                        }
                    }
                },
                rangeSelector: {
                    buttonTheme: {
                        fill: 'none',
                        stroke: 'none',
                        'stroke-width': 0,
                        r: 4,
                        style: {
                            fontWeight: 'bold',
                            color: '#666',
                        },
                        states: {
                            hover: {
                                fill: '#68b6f3',
                                fontWeight: 'bold',
                                style: {
                                    color: '#fff'
                                }
                            },
                            select: {
                                fill: '#fff',
                                fontWeight: 'bold',
                                style: {
                                    color: '#1C80CE',
                                }
                            }
                            // disabled: { ... }
                        }
                    },
                    buttons: [
                        {
                            type: 'all',
                            //count: 1,
                            text: '24h',
                            events: {
                                click: function () {
                                    if (selfClass.lastRequestDataParams.name != '24h') {
                                        // @ts-ignore
                                        window.chartData = null;
                                        // @ts-ignore
                                        selfClass.lastRequestDataParams = { range: this.text, selected: 0 };
                                        selfClass.changePercentInCoinPdp();
                                        afterNextPaint().then(() => selfClass.makeChart());
                                    }
                                    return false;
                                }
                            },
                        },
                        {
                            type: 'all',
                            //count: 1,
                            text: '1w',
                            events: {
                                click: function () {
                                    if (selfClass.lastRequestDataParams.name != '1w') {
                                        // @ts-ignore
                                        window.chartData = null;
                                        // @ts-ignore
                                        selfClass.lastRequestDataParams = { range: this.text, selected: 1 };
                                        selfClass.changePercentInCoinPdp();
                                        afterNextPaint().then(() => selfClass.makeChart());
                                    }
                                    return false;
                                }
                            },
                        },
                        {
                            type: 'all',
                            //count: 1,
                            text: '1m',
                            events: {
                                click: function () {
                                    if (selfClass.lastRequestDataParams.name != '1m') {
                                        // @ts-ignore
                                        window.chartData = null;
                                        // @ts-ignore
                                        selfClass.lastRequestDataParams = { range: this.text, selected: 2 };
                                        selfClass.changePercentInCoinPdp();
                                        afterNextPaint().then(() => selfClass.makeChart());
                                    }
                                    return false;
                                }
                            },
                        }, {
                            type: 'all',
                            //count: 3,
                            text: '3m',
                            events: {
                                click: function () {
                                    if (selfClass.lastRequestDataParams.name != '3m') {
                                        // @ts-ignore
                                        window.chartData = null;
                                        // @ts-ignore
                                        selfClass.lastRequestDataParams = { range: this.text, selected: 3 };
                                        selfClass.changePercentInCoinPdp();
                                        afterNextPaint().then(() => selfClass.makeChart());
                                    }
                                    return false;
                                }
                            },
                        }, {
                            type: 'all',
                            //count: 1,
                            text: '1y',
                            events: {
                                click: function () {
                                    if (selfClass.lastRequestDataParams.name != '1y') {
                                        // @ts-ignore
                                        window.chartData = null;
                                        // @ts-ignore
                                        selfClass.lastRequestDataParams = { range: this.text, selected: 4 };
                                        selfClass.changePercentInCoinPdp();
                                        afterNextPaint().then(() => selfClass.makeChart());
                                    }
                                    return false;
                                }
                            },
                        }, {
                            type: 'all',
                            text: 'ALL',
                            events: {
                                click: function () {
                                    if (selfClass.lastRequestDataParams.name != 'ALL') {
                                        // @ts-ignore
                                        window.chartData = null;
                                        // @ts-ignore
                                        selfClass.lastRequestDataParams = { range: this.text, selected: 5 };
                                        selfClass.changePercentInCoinPdp();
                                        afterNextPaint().then(() => selfClass.makeChart());
                                    }
                                    return false;
                                }
                            },
                        }
                    ],
                    inputEnabled: false,
                    allButtonsEnabled: true,
                    selected: selfClass.lastRequestDataParams.selected,
                    verticalAlign: !document.body.classList.contains('mobile') ? 'top' : 'bottom',
                    buttonPosition: {
                        align: !document.body.classList.contains('mobile') ? 'left' : 'center',
                        x: 0,
                        y: 0
                    }
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        dataGrouping: {
                            smoothed: true,
                            enabled: false,
                        },
                    },
                    flags: {
                        animation: false,
                        enableMouseTracking: false,
                        fillColor: 'transparent',
                        lineColor: 'transparent',
                        lineWidth: 0,
                        shape: 'squarepin',
                        useHTML: true,
                        style: {
                            color: 'transparent',
                            fontSize: '11px',
                            fontWeight: 'normal',
                        },
                        states: {
                            hover: {
                                enabled: false,
                            },
                        },
                    },
                },
                legend: {
                    enabled: true
                },
                series: [
                    {
                        name: 'قیمت دلاری',
                        threshold: null,
                        data: this.chartData[this.lastRequestDataParams.name].dollar,
                        type: 'areaspline',
                        color: coin_info.color,
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, coin_info.color + '20'],
                                [1, 'transparent']
                            ]
                        },
                        lineWidth: 2,
                        yAxis: 1,
                        states: {
                            hover: {
                                lineWidth: 2
                            }
                        },
                        visible: this.chartType == 'irt' ? false : true,
                        softThreshold: true,
                        events: {
                            legendItemClick: function () {
                                selfClass.setCurrency('usd');
                                return false;
                            }
                        },
                    },
                    {
                        name: 'قیمت تومانی',
                        threshold: null,
                        data: this.chartData[this.lastRequestDataParams.name].toman,
                        visible: this.chartType == 'irt' ? true : false,
                        type: 'areaspline',
                        color: coin_info.color,
                        yAxis: 0,
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, coin_info.color + '20'],
                                [1, 'transparent']
                            ]
                        },
                        lineWidth: 2,
                        states: {
                            hover: {
                                lineWidth: 2
                            }
                        },
                        softThreshold: true,
                        events: {
                            legendItemClick: function () {
                                selfClass.setCurrency('irt');
                                return false;
                            }
                        }
                    },
                    {
                        name: 'flag',
                        type: 'flags',
                        className: 'arz-chart-extrema-flag',
                        showInLegend: false,
                        yAxis: 1,
                        visible: this.chartType == 'irt' ? false : true,
                        y: -26,
                        data: [data.dmax],
                    },
                    {
                        name: 'flag',
                        type: 'flags',
                        className: 'arz-chart-extrema-flag',
                        showInLegend: false,
                        yAxis: 1,
                        visible: this.chartType == 'irt' ? false : true,
                        y: 4,
                        data: [data.dmin],
                    },
                    {
                        name: 'flag',
                        type: 'flags',
                        className: 'arz-chart-extrema-flag',
                        showInLegend: false,
                        yAxis: 0,
                        visible: this.chartType == 'irt' ? true : false,
                        y: -26,
                        data: [data.tmax],
                    },
                    {
                        name: 'flag',
                        type: 'flags',
                        className: 'arz-chart-extrema-flag',
                        showInLegend: false,
                        yAxis: 0,
                        visible: this.chartType == 'irt' ? true : false,
                        y: 4,
                        data: [data.tmin],
                    },
                ],
                tooltip: {
                    outside: true,
                    borderRadius: 20,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    shadow: false,
                    backgroundColor: '#ffffff',
                    split: false,
                    shared: true,
                    useHTML: true,
                    style: {
                        direction: 'rtl',
                        textAlign: 'right',
                        lineHeight: '25px',
                        zIndex: 30,
                    },
                    formatter: function () {
                        if (!this.points)
                            return;
                        var gdate = new Date(this.x);
                        const yearFormat = new Intl.DateTimeFormat('fa-IR', { year: 'numeric' });
                        const monthFormat = new Intl.DateTimeFormat('fa-IR', { month: 'long' });
                        const dayFormat = new Intl.DateTimeFormat('fa-IR', { day: '2-digit' });
                        const year = yearFormat.format(gdate);
                        const famonth = monthFormat.format(gdate);
                        const day = dayFormat.format(gdate);
                        var time = gdate.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' });
                        var persianDate = `${day} ${famonth} ${year}`;
                        var gregorianDate = `${gdate.getFullYear()} ${gdate.toLocaleString('en-US', { month: 'short' })} ${gdate.getDate()}`;
                        var isDollarChart = this.points[0].series.index == 0;
                        var priceDollar = isDollarChart ? this.y : this.points[0].point.dollar;
                        var priceToman = isDollarChart ? this.points[0].point.toman : this.y;
                        var oneDollar = this.points[0].point.oneDollar;
                        var res = `<div>
                <div style='display:flex;gap:5px;'>
                  <span> ${persianDate} </span> | <span style='direction: ltr;'> ${gregorianDate} </span> | <span > ${time} </span>
                </div>
                <div>
                  <span style="color:#30505C">●</span> <span>قیمت دلاری</span>: <b style='direction: ltr;display: inline-block;'>${formatterUsd.toString(priceDollar)}</b>					
                </div>
                <div>
                  <span style="color:#30505C">●</span> <span>قیمت تومانی</span>: <b>${formatterIrt.toString(priceToman)}</b>					
                </div>
                <div>
                  <span style="color:#ff6868">●</span> <span>نرخ دلار</span>: <b>${formatterIrt.toString(oneDollar)}</b>					
                </div>
                
              </div>`;
                        return res;
                    }
                }
            };
            if (document.body.classList.contains('mobile')) {
                args.chart.height = '290px';
                args.rangeSelector.buttonTheme.style.fontSize = '15px';
                const rangeLayout = (0, chart_settings_1.getMobileRangeSelectorLayout)((_a = document.getElementById(this.container)) === null || _a === void 0 ? void 0 : _a.clientWidth, this.mobileRangeTrailingSlots);
                args.rangeSelector.buttonSpacing = rangeLayout.buttonSpacing;
                // Highstock 8 applies buttonPosition.x twice (button offset and group alignment).
                args.rangeSelector.buttonPosition.x = rangeLayout.x / 2;
                /*
                args.yAxis.push({
                  tickAmount: 6,
                  visible: false,
                });
                */
                args.xAxis.visible = false;
            }
            else if ((0, chart_settings_1.shouldRenderLivePricePlotLines)(this.livePriceEnabled && this.metric === 'price', this.prefix, document.body.classList.contains('mobile'))) {
                args.yAxis[0].plotLines = [{
                        id: 'lastPrice',
                        value: lastDataToman.y,
                        color: positiveColor,
                        width: 1,
                        dashStyle: 'LongDashDot',
                        label: {
                            text: (0, chart_labels_1.rtlChartAmount)(formatterIrt.toString(lastDataToman.y)),
                            className: 'arz-chart-last-price-label',
                            align: 'right',
                            x: -20,
                            style: {
                                color: onStateColor,
                                backgroundColor: positiveColor,
                                padding: '3px 5px',
                                borderRadius: '5px',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            },
                            useHTML: true
                        }
                    }];
                args.yAxis[1].plotLines = [{
                        id: 'lastPrice',
                        value: lastDataDollar.y, // مقدار آخرین قیمت
                        color: positiveColor,
                        width: 1,
                        dashStyle: 'LongDashDot',
                        label: {
                            text: formatterUsd.toString(lastDataDollar.y),
                            className: 'arz-chart-last-price-label',
                            align: 'right',
                            x: -20,
                            style: {
                                color: onStateColor,
                                backgroundColor: positiveColor,
                                padding: '3px 5px',
                                borderRadius: '5px',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            },
                            useHTML: true
                        }
                    }];
            }
            if ((_b = this.chart) === null || _b === void 0 ? void 0 : _b.renderTo) {
                try {
                    this.chart.destroy();
                }
                catch (e) {
                    console.log(`erro in chart destroy ${elem}`, e);
                }
            }
            if (this.metric !== 'price') {
                const metric = this.metric;
                const label = chart_metrics_1.COIN_CHART_METRICS[metric];
                const format = (value) => (0, chart_metrics_1.formatMetricValue)(value, metric, coin_info.symbol);
                args.yAxis[0].visible = false;
                args.yAxis[1].visible = true;
                args.yAxis[1].minRange = 0;
                args.yAxis[1].floor = this.logarithmicEnabled ? undefined : 0;
                args.yAxis[1].tickPositioner = function () {
                    if (this.logarithmic)
                        return undefined;
                    return this.tickPositions.filter((value) => value >= 0);
                };
                const bounds = (0, chart_metrics_1.getMetricAxisBounds)(data.dmin.y, data.dmax.y, this.logarithmicEnabled, document.body.classList.contains('mobile'));
                if (bounds)
                    Object.assign(args.yAxis[1], bounds);
                args.yAxis.forEach((axis) => { axis.plotLines = []; });
                args.yAxis[1].labels.formatter = function () { return format(this.value); };
                args.series.forEach((series, index) => {
                    series.visible = [0, 2, 3].includes(index);
                    series.showInLegend = index === 0;
                });
                args.series[0].name = label;
                args.series[0].events.legendItemClick = () => false;
                data.dmin.title = this.extremaFlagTitle(format(data.dmin.y), 'top');
                data.dmax.title = this.extremaFlagTitle(format(data.dmax.y), 'bottom');
                args.tooltip.formatter = function () {
                    var _a;
                    if (!((_a = this.points) === null || _a === void 0 ? void 0 : _a.length))
                        return;
                    const date = new Date(this.x);
                    const persianDate = date.toLocaleDateString('fa-IR', { day: '2-digit', month: 'long', year: 'numeric' });
                    const gregorianDate = `${date.getFullYear()} ${date.toLocaleString('en-US', { month: 'short' })} ${date.getDate()}`;
                    const time = date.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' });
                    return `<div><div style="display:flex;gap:5px"><span>${persianDate}</span> | <span dir="ltr">${gregorianDate}</span> | <span>${time}</span></div><div><span style="color:#30505C">●</span> <span>${label}</span>: <b dir="ltr" style="display:inline-block">${format(this.y)}</b></div></div>`;
                };
            }
            // Start at the rescaled range so the chart renders once (axes use startOnTick/endOnTick false).
            if (this.prefix === 'coindetails') {
                const chartWidth = ((_c = document.getElementById(elem)) === null || _c === void 0 ? void 0 : _c.clientWidth) || 0;
                [[0, 1], [1, 0]].forEach(([seriesIndex, axisIndex]) => {
                    var _a;
                    const bounds = this.priceAxisBounds(this.priceAxisSource(axisIndex) || ((_a = args.series[seriesIndex]) === null || _a === void 0 ? void 0 : _a.data) || [], chartWidth);
                    if (bounds)
                        Object.assign(args.yAxis[axisIndex], bounds);
                });
            }
            this.chart = window.Highcharts.stockChart(elem, args);
            this.isFirstTime = 0;
        });
    }
    ;
    makeChart3() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const selfClass = this;
            var elem = this.container;
            var lastSeries;
            if (this.chart != undefined) {
                lastSeries = this.chart.series.findIndex(function (items) { return items.visible == true; });
                this.chart.destroy();
            }
            const tmin = this.chartData[this.lastRequestDataParams.name].tmin, tmax = this.chartData[this.lastRequestDataParams.name].tmax;
            const tmin2 = tmin[1];
            const tmax2 = tmax[1] + ((tmax[1] - tmin[1]) * 40 / (360 - 40));
            const min = this.chartData[this.lastRequestDataParams.name].min, max = this.chartData[this.lastRequestDataParams.name].max;
            const min2 = min[1];
            const max2 = max[1] + ((max[1] - min[1]) * 40 / (360 - 40));
            const usdtmin = this.chartData[this.lastRequestDataParams.name].usdtmin, usdtmax = this.chartData[this.lastRequestDataParams.name].usdtmax;
            const usdtmin2 = usdtmin[1];
            const usdtmax2 = usdtmax[1] + ((usdtmax[1] - usdtmin[1]) * 40 / (360 - 40));
            let args = {
                chart: {
                    zoomType: 'x',
                    resetZoomEnabled: true,
                    style: {
                        fontFamily: 'yekan bakh',
                    },
                    height: '550px',
                },
                credits: {
                    href: '',
                    text: '',
                },
                yAxis: [
                    {
                        className: 'arz-coin-main-grid',
                        tickAmount: 10,
                        opposite: false,
                        alignTicks: true,
                        labels: {
                            align: 'left',
                            x: 3,
                            style: {
                                color: '#999',
                            }
                        },
                        title: {
                            useHTML: true,
                            style: {
                                color: '#ff5d5d',
                            }
                        },
                        top: '0%',
                        height: '80%',
                        offset: 0,
                        lineWidth: 0,
                        startOnTick: false,
                        endOnTick: false,
                        min: min2,
                        max: max2
                    },
                    {
                        tickAmount: 6,
                        labels: {
                            align: 'right',
                            x: -3,
                            style: {
                                color: '#999',
                            }
                        },
                        title: {
                            useHTML: true,
                            style: {
                                color: '#999',
                            }
                        },
                        height: '70%',
                        opposite: true,
                        alignTicks: true,
                        lineWidth: 0,
                        gridLineColor: 'transparent',
                        startOnTick: false,
                        endOnTick: false,
                        min: tmin2,
                        max: tmax2
                    },
                    {
                        labels: {
                            align: 'right',
                            useHTML: true,
                            x: -3,
                            style: {
                                color: '#000',
                                backgroundColor: '#ffffffbf',
                            }
                        },
                        title: {
                            //text: 'قیمت دلار به تومان',
                            useHTML: true,
                            style: {
                                color: '#4ca8d6',
                            }
                        },
                        top: '80%',
                        height: '20%',
                        offset: 0,
                        lineWidth: 0,
                        gridLineColor: 'transparent',
                        plotBands: [{
                                from: 0,
                                to: 20000,
                                color: '#fff',
                            }],
                        startOnTick: false,
                        endOnTick: false,
                        min: usdtmin2,
                        max: usdtmax2
                    }
                ],
                xAxis: {
                    labels: {
                        //format: '{value:%e %b}',
                        style: {
                            direction: 'rtl',
                        }
                    },
                    ordinal: false,
                    events: {
                        setExtremes: (event) => {
                            if (event.trigger == 'zoom') {
                                const zoomButton = this.chart.renderer.button('لغو بزرگنمایی', 0, 0, () => {
                                    this.lastRequestDataParams = {
                                        selected: this.lastRequestDataParams.selected,
                                        range: this.lastRequestDataParams.range
                                    };
                                    this.makeChart();
                                }, {
                                    zIndex: 5
                                }).attr({
                                    id: 'resetZoom',
                                    align: 'right',
                                    title: 'Reset zoom level 1:1'
                                }).add().align({
                                    align: 'right',
                                    x: -15,
                                    y: 40
                                }, false);
                                // if ((event.max - event.min) > (24 * 3600 * 1000)) {
                                //   this.lastRequestDataParams.from = Math.floor(event.min);
                                //   this.lastRequestDataParams.to = Math.floor(event.max);
                                //   this.makeChart();
                                // }
                                // else {
                                //   this.chart.xAxis[0].setExtremes();
                                // }
                            }
                        },
                    }
                },
                rangeSelector: {
                    buttonTheme: {
                        fill: 'none',
                        stroke: 'none',
                        'stroke-width': 0,
                        r: 4,
                        style: {
                            fontWeight: 'bold',
                            color: '#666',
                        },
                        states: {
                            hover: {
                                fill: '#68b6f3',
                                fontWeight: 'bold',
                                style: {
                                    color: '#fff'
                                }
                            },
                            select: {
                                fill: '#fff',
                                fontWeight: 'bold',
                                style: {
                                    color: '#1C80CE',
                                }
                            }
                            // disabled: { ... }
                        }
                    },
                    buttons: [
                        {
                            type: 'day',
                            count: 1,
                            text: '24h',
                            events: {
                                click: function () {
                                    // @ts-ignore
                                    selfClass.lastRequestDataParams = { range: this.text, selected: 0 };
                                    afterNextPaint().then(() => selfClass.makeChart());
                                    return false;
                                }
                            },
                        },
                        {
                            type: 'week',
                            count: 1,
                            text: '1w',
                            events: {
                                click: function () {
                                    // @ts-ignore
                                    selfClass.lastRequestDataParams = { range: this.text, selected: 1 };
                                    afterNextPaint().then(() => selfClass.makeChart());
                                    return false;
                                }
                            },
                        },
                        {
                            type: 'month',
                            count: 1,
                            text: '1m',
                            events: {
                                click: function () {
                                    // @ts-ignore
                                    selfClass.lastRequestDataParams = { range: this.text, selected: 2 };
                                    afterNextPaint().then(() => selfClass.makeChart());
                                    return false;
                                }
                            },
                        }, {
                            type: 'month',
                            count: 3,
                            text: '3m',
                            events: {
                                click: function () {
                                    // @ts-ignore
                                    selfClass.lastRequestDataParams = { range: this.text, selected: 3 };
                                    afterNextPaint().then(() => selfClass.makeChart());
                                    return false;
                                }
                            },
                        }, {
                            type: 'year',
                            count: 1,
                            text: '1y',
                            events: {
                                click: function () {
                                    // @ts-ignore
                                    selfClass.lastRequestDataParams = { range: this.text, selected: 4 };
                                    afterNextPaint().then(() => selfClass.makeChart());
                                    return false;
                                }
                            },
                        }, {
                            type: 'all',
                            text: 'ALL',
                            events: {
                                click: function () {
                                    // @ts-ignore
                                    selfClass.lastRequestDataParams = { range: this.text, selected: 5 };
                                    afterNextPaint().then(() => selfClass.makeChart());
                                    return false;
                                }
                            },
                        }
                    ],
                    inputEnabled: false,
                    allButtonsEnabled: true,
                    selected: selfClass.lastRequestDataParams.selected,
                },
                scrollbar: {
                    enabled: false
                },
                legend: {
                    enabled: true,
                    useHTML: true,
                },
                plotOptions: {
                    series: {
                        /*
              dataGrouping: {
                            smoothed:true,
                            enabled:false,
                        },
              */
                        stacking: 'normal',
                    }
                },
                series: [
                    {
                        yAxis: 0,
                        type: 'area',
                        name: '<span dir="auto">قیمت ' + coin_info.faname + '</span>',
                        tooltip: {
                            pointFormatter: function (pointStr) {
                                const point = this;
                                pointStr = pointStr.replace("{point.y}", arzDigital.normalizeDecimal(point.y) + ' $');
                                pointStr = pointStr.replace("{point.color}", point.color);
                                pointStr = pointStr.replace("{series.name}", point.series.name);
                                return pointStr;
                            },
                        },
                        color: coin_info.color,
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, coin_info.color + '20'],
                                [1, 'transparent']
                            ]
                        },
                        data: selfClass.chartData[selfClass.lastRequestDataParams.name].dollar,
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        softThreshold: true,
                        stack: 0,
                    },
                    {
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        type: 'area',
                        name: '<span dir="auto">برابر با</span>',
                        yAxis: 1,
                        tooltip: {
                            pointFormatter: function (pointStr) {
                                const point = this;
                                pointStr = pointStr.replace("{point.y}", arzDigital.normalizeDecimal(point.y) + ' تومان');
                                pointStr = pointStr.replace("{point.color}", point.color);
                                pointStr = pointStr.replace("{series.name}", point.series.name);
                                return pointStr;
                            }
                        },
                        color: '#30505C',
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, 'transparent'],
                                [1, 'transparent']
                            ]
                        },
                        data: selfClass.chartData[selfClass.lastRequestDataParams.name].tomani,
                        softThreshold: true,
                        stack: 0,
                    },
                    {
                        type: 'area',
                        lineWidth: 1,
                        name: '<span dir="auto">نرخ دلار</span>',
                        data: selfClass.chartData[selfClass.lastRequestDataParams.name].usdt,
                        yAxis: 2,
                        tooltip: {
                            valueSuffix: ' تومان',
                            valueDecimals: 0,
                        },
                        color: '#10d39a',
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, '#10d39a20'],
                                [1, 'transparent']
                            ]
                        },
                        softThreshold: true,
                    }
                ],
                tooltip: {
                    split: false,
                    shared: true,
                    useHTML: true,
                    style: {
                        direction: 'rtl',
                        textAlign: 'right',
                        lineHeight: '20px',
                    },
                    borderRadius: 20,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    shadow: false,
                    backgroundColor: '#ffffff',
                    formatter: function (tooltip) {
                        if (!this.points)
                            return;
                        var pointTimestamp = this.x, faDate = new window.JDate(pointTimestamp), enDate = new Date(pointTimestamp !== null && pointTimestamp !== void 0 ? pointTimestamp : ''), enDateStr = enDate.getFullYear() + ' ' + selfClass.enShortMonthes[enDate.getMonth()] + ' ' + enDate.getDate(), faDateStr = faDate.getDate() + ' ' + selfClass.faMonthes[faDate.getMonth()] + ' ' + faDate.getFullYear(), time = enDate.getHours() + ':' + enDate.getMinutes(), a = tooltip.defaultFormatter.call(this, tooltip);
                        a[0] = `<span style='font-size: 10px'><span dir='auto'>${faDateStr}</span> | <span dir='auto'>${enDateStr}</span> | <span>${time}</span></span><br/>`;
                        return a;
                    },
                }
            };
            if (tmin) {
                if (!args.plotOptions)
                    args.plotOptions = {};
                args.plotOptions.flags = {
                    //useHTML:true,
                    style: { "fontSize": "11px", "fontWeight": "normal" },
                    lineColor: '#ccc',
                };
                args.series.push({
                    type: 'flags',
                    showInLegend: false,
                    useHTML: true,
                    yAxis: 1,
                    data: [{
                            x: tmin[0],
                            y: tmin[1],
                            title: '<span dir="auto">' + arzDigital.normalizeDecimal(tmin[1]) + ' تومان</span>',
                        },
                        {
                            x: tmax[0],
                            y: tmax[1],
                            title: '<span dir="auto">' + arzDigital.normalizeDecimal(tmax[1]) + ' تومان</span>',
                        }],
                });
            }
            if ((_a = this.chart) === null || _a === void 0 ? void 0 : _a.renderTo) {
                try {
                    this.chart.destroy();
                }
                catch (e) {
                    console.log(`erro in chart destroy ${elem}`, e);
                }
            }
            this.chart = window.Highcharts.stockChart(elem, args);
        });
    }
    ;
}
exports.chart = chart;
